export const fadeUp = {
  hidden: { opacity: 0, y: 48 },
  show: (i = 0) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.9, delay: i * 0.12, ease: [0.16, 1, 0.3, 1] },
  }),
};

export const lineReveal = {
  hidden: { y: "115%" },
  show: (i = 0) => ({
    y: "0%",
    transition: { duration: 1.1, delay: 0.15 + i * 0.14, ease: [0.16, 1, 0.3, 1] },
  }),
};

export const viewportOnce = { once: true, margin: "-80px" };
